document.addEventListener("DOMContentLoaded", function () {
  var descriptions = document.querySelectorAll(".seo-h1-description");
  var maxChars = 180;

  descriptions.forEach(function (desc) {
    var paragraphs = desc.querySelectorAll("p");
    if (paragraphs.length <= 1) return;

    var firstP = paragraphs[0];
    var fullText = firstP.innerText.trim();
    var shortText =
      fullText.length > maxChars
        ? fullText.substring(0, maxChars).trim()
        : fullText;

    var hiddenContent = "";

    for (var i = 1; i < paragraphs.length; i++) {
      hiddenContent += paragraphs[i].outerHTML;
      paragraphs[i].remove();
    }

    firstP.dataset.fullText = fullText;
    firstP.dataset.shortText = shortText;

    var btn = document.createElement("span");
    btn.className = "seo-h1-readmore";
    btn.innerText = "...הצג עוד";

    btn.addEventListener("click", function () {
      toggleReadmore(desc, btn);
    });

    firstP.innerHTML = shortText;
    firstP.appendChild(btn);

    var hiddenWrapper = document.createElement("div");
    hiddenWrapper.className = "seo-h1-hidden";
    hiddenWrapper.innerHTML = hiddenContent;
    hiddenWrapper.style.display = "none";

    desc.appendChild(hiddenWrapper);
  });
});

function toggleReadmore(desc, btn) {
  var firstP = desc.querySelector("p");
  var hidden = desc.querySelector(".seo-h1-hidden");

  if (hidden.style.display === "block") {
    hidden.style.display = "none";
    btn.innerText = "...הצג עוד";

    firstP.innerHTML = firstP.dataset.shortText;
    firstP.appendChild(btn);
  } else {
    hidden.style.display = "block";
    btn.innerText = "הצג פחות";

    firstP.innerText = firstP.dataset.fullText;
    hidden.appendChild(btn);
  }
}
